enum EnumNewsType {
	Top = 0,
	Blog = 1,
	Pressa = 2
}
export default EnumNewsType



// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/DataModels/Enums/EnumNewsType.ts